import {createActions} from 'reduxsauce';

export const {Types: SubscribeTypes, Creators: SubscribeActionCreators} = createActions ({
    subscribeStart: ['body'],
    subscribeSuccess: ['data'],
    subscribeFailure: ['error']
});
